import React from 'react';
import Checkbox from '../../../../../core/controls/checkbox/Checkbox';
import { useModelInfo } from '../../../../common/ModelInfoContext';
import { updateReservationWithDriveType } from '../../../../store/actions/reservation';
import { connect } from 'react-redux';
import SvgIcon from '../../../../../core/icons/SvgIcon';
import { TRIMS } from '../../../../common/steps';

const AlternateDriveTypeCheckbox = ({
  appResources,
  reservation,
  onDriveTypeUpdateReservation,
  selections,
  step = TRIMS,
}) => {
  const modelInfo = useModelInfo();
  const { hasTransactionId } = modelInfo;
  const { alternateDriveType, processSteps } = appResources;
  const { tidSubHeader } = processSteps?.find((stp) => stp.key === step);
  const showAltDriveType = alternateDriveType?.styles?.find(
    (trim) => trim === selections.styleId
  );

  return (
    <>
      {hasTransactionId && alternateDriveType && (
        <div className="alternate-drive__container">
          <SvgIcon name="availability" className="alternate-drive__icon" />
          <div className="alternate-drive">
            <span
              className="alternate-drive__description"
              dangerouslySetInnerHTML={{ __html: tidSubHeader }}
            />
            {showAltDriveType && (
              <Checkbox
                analyticsKey={alternateDriveType.code}
                checked={reservation.alternateDriveType}
                value={alternateDriveType.code}
                onChange={onDriveTypeUpdateReservation}
                customModifier="feature-filter"
                className="alternate-drive__checkbox"
                customCheckName="check-mark">
                <span className="alternate-drive__label">
                  {alternateDriveType.checkBoxLabel}
                </span>
              </Checkbox>
            )}
          </div>
        </div>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  const onDriveTypeUpdateReservation = (event) => {
    dispatch(
      updateReservationWithDriveType(
        event.target.checked && event.target.value ? event.target.value : ''
      )
    );
  };

  return {
    onDriveTypeUpdateReservation,
  };
};

const mapStateToProps = (state) => {
  const { appResources, reservation, config } = state;

  return {
    reservation,
    appResources,
    selections: config?.selections,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AlternateDriveTypeCheckbox);
